@use '~@frontrow/console/css/variables.scss';

.sismatchesActionButton {
  display: flex;
  justify-content: flex-end;
  margin: variables.$std-margin-lg;
  margin-bottom: variables.$std-margin-5xl;
}
